import React from "react";
import { Outlet, Navigate, Link } from "react-router-dom";
import { useTenant } from "../../lib/TenantContext";
import {
  Brain,
  Users,
  LayoutDashboard,
  LogOut,
  CreditCard,
} from "lucide-react";

export const AdminShell: React.FC = () => {
  const { isSuperAdmin, signOut } = useTenant();

  // Strict isolation. If someone accesses /admin without superadmin rights, kick them out to root.
  if (!isSuperAdmin) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex h-screen w-full bg-[#f3f4f6]">
      {/* Super Admin Sidebar (Light Mode) */}
      <div className="w-64 bg-white flex flex-col items-center py-8 relative flex-shrink-0 border-r border-brand-200">
        {/* Brand */}
        <div className="flex flex-col items-center mb-12 relative w-full px-6">
          <div className="w-16 h-16 bg-brand-100 rounded-2xl flex items-center justify-center mb-4 border border-brand-200">
            <Brain size={32} strokeWidth={1.5} className="text-gray-900" />
          </div>
          <h1 className="text-xl font-bold tracking-tight text-gray-900 mb-1">
            OsirisBrain ERP
          </h1>
          <p className="text-[10px] text-gray-500 font-semibold tracking-[0.2em] uppercase">
            Master Console
          </p>
        </div>

        {/* Navigation */}
        <nav className="flex-1 w-full px-4 space-y-1">
          <div className="text-[10px] font-medium text-gray-400 uppercase tracking-widest px-4 mb-2">
            Principal
          </div>
          <Link
            to="/admin"
            className="flex items-center gap-3 w-full px-4 py-3 rounded-xl text-sm font-semibold text-gray-900 bg-brand-100 transition-colors border border-brand-200"
          >
            <LayoutDashboard size={18} /> Resumen General
          </Link>
          <div className="text-[10px] font-medium text-gray-400 uppercase tracking-widest px-4 mt-6 mb-2">
            Clientes
          </div>
          <Link
            to="/admin/tenants"
            className="flex items-center gap-3 w-full px-4 py-3 rounded-xl text-sm font-medium text-brand-500 hover:bg-brand-100 hover:text-gray-900 transition-colors"
          >
            <Users size={18} /> Gestión de Comercios
          </Link>
          <Link
            to="/admin/tenants"
            className="flex items-center gap-3 w-full px-4 py-3 rounded-xl text-sm font-medium text-brand-500 hover:bg-brand-100 hover:text-gray-900 transition-colors"
          >
            <CreditCard size={18} /> Facturación & Pagos
          </Link>
        </nav>

        {/* Master User Profile */}
        <div className="mt-8 px-6 w-full absolute bottom-8">
          <div className="p-4 rounded-xl bg-brand-50 border border-brand-200 flex flex-col gap-4">
            <div className="flex flex-col">
              <span className="text-xs uppercase tracking-wider text-gray-500 font-bold mb-1">
                Administrador
              </span>
              <span className="text-sm font-medium text-gray-900 break-all leading-tight">
                OsirisBrain Central
              </span>
            </div>
            <button
              onClick={signOut}
              className="w-full py-2.5 rounded-lg bg-red-50 text-red-600 text-xs font-bold hover:bg-red-100 transition-colors flex items-center justify-center gap-2 border border-red-100"
            >
              <LogOut size={14} /> Desconectar
            </button>
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <main className="flex-1 flex flex-col min-w-0 bg-brand-50">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminShell;
